import { forwardRef, type Ref, type SVGProps } from "react";

function SvgFail(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#fail_svg__a)"
        strokeWidth={10}
        d="M55 27.1C55 19.313 62.163 13 71 13h32c8.837 0 16 6.313 16 14.1v65.8c0 7.787-7.163 14.1-16 14.1H71c-8.837 0-16-6.313-16-14.1z"
      />
      <rect width={39} height={39} x={99.5} y={40.5} fill="#B01921" rx={19.5} />
      <rect width={39} height={39} x={99.5} y={40.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M119 54v7m0 3v1"
      />
      <circle cx={88} cy={90} r={5} stroke="#0C1C43" />
      <defs>
        <linearGradient
          id="fail_svg__a"
          x1={87}
          x2={86.406}
          y1={13}
          y2={83.999}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgFail);
export default ForwardRef;
